import React from 'react';
import { Box } from '../../../../primitives/Box';

export const NoResults: React.FC = ({ children }) => (
    <Box px="md" py="sm">
        {children}
    </Box>
);
